import { useMessageSigner } from '../hooks';

function MessageSigner(): JSX.Element {
  const {
    mnemonic,
    setMnemonic,
    message,
    setMessage,
    useEIP712,
    setUseEIP712,
    addressIndex,
    setAddressIndex,
    result,
    loading,
    signMessage,
    isReady
  } = useMessageSigner();

  return (
    <div className="component">
      <h3>Message Signer</h3>
      <p>Sign messages with your private key</p>
      
      <div className="form-group">
        <label htmlFor="mnemonic">Mnemonic Phrase:</label>
        <textarea
          id="mnemonic"
          value={mnemonic}
          onChange={(e) => setMnemonic(e.target.value)}
          placeholder="Enter your mnemonic phrase..."
          rows={2}
        />
      </div>

      <div className="form-group">
        <label htmlFor="message">Message to Sign:</label>
        <textarea
          id="message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Enter message to sign..."
          rows={3}
        />
      </div>

      <div className="form-group">
        <label htmlFor="addressIndex">Address Index:</label>
        <input
          id="addressIndex"
          type="number"
          value={addressIndex}
          onChange={(e) => setAddressIndex(parseInt(e.target.value) || 0)}
          min="0"
          max="1000"
        />
      </div>

      <div className="form-group">
        <label>
          <input
            type="checkbox"
            checked={useEIP712}
            onChange={(e) => setUseEIP712(e.target.checked)}
            style={{ marginRight: '0.5rem' }}
          />
          Use EIP-712 Typed Data
        </label>
      </div>

      <button 
        className="button" 
        onClick={signMessage}
        disabled={loading || !isReady}
      >
        {loading ? 'Signing...' : 'Sign Message'}
      </button>

      {result && (
        <div className={`output ${result.success ? 'success' : 'error'}`}>
          {result.success ? (
            <>
              <strong>Signature:</strong><br/>
              {result.signature}<br/><br/>
              <strong>Details:</strong><br/>
              Message: {result.message}<br/>
              EIP-712: {result.options?.useEIP712 ? 'Yes' : 'No'}<br/>
              Address Index: {result.options?.addressIndex || 0}
            </>
          ) : (
            <>
              <strong>Error:</strong><br/>
              {result.error}
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default MessageSigner;
